import api from '@/utils/api';
import {
    CREATE_ORTHODONTIC_COMMENT,
    UPDATE_ORTHODONTIC_COMMENT,
    DELETE_ORTHODONTIC_COMMENT,
    GET_ORTHODONTIC_COMMENTS
} from './types';
import { NotificationManager } from 'react-notifications';

// Lấy danh sách comment theo plan
export const getOrthodonticComments = (planId) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get(`/orthodontic-comments/plan/${planId}`).then(res => {
            dispatch({
                type: GET_ORTHODONTIC_COMMENTS,
                payload: res.data.data
            });
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || "Lỗi khi tải danh sách bình luận");
            reject(err);
        });
    });
};

// Tạo comment
export const createOrthodonticComment = (planId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.post(`/orthodontic-comments/plan/${planId}/comments`, data).then(res => {
            dispatch({
                type: CREATE_ORTHODONTIC_COMMENT,
                payload: res.data.data
            });
            NotificationManager.success(res.data.msg || "Thêm bình luận thành công!");
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || "Lỗi khi thêm bình luận");
            reject(err);
        });
    });
};

// Cập nhật comment
export const updateOrthodonticComment = (planId, id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.put(`/orthodontic-comments/plan/${planId}/comments/${id}`, data).then(res => {
            dispatch({
                type: UPDATE_ORTHODONTIC_COMMENT,
                payload: res.data.data
            });
            NotificationManager.success(res.data.msg || "Cập nhật bình luận thành công!");
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || "Lỗi khi cập nhật bình luận");
            reject(err);
        });
    });
};

// Xóa comment
export const deleteOrthodonticComment = (planId, id) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.delete(`/orthodontic-comments/plan/${planId}/comments/${id}`).then(res => {
            dispatch({
                type: DELETE_ORTHODONTIC_COMMENT,
                payload: id
            });
            NotificationManager.success(res.data.msg || "Xóa bình luận thành công!");
            resolve(res.data);
        }).catch(err => {
            console.error(err);
            NotificationManager.error(err.response?.data?.msg || "Lỗi khi xóa bình luận");
            reject(err);
        });
    });
};
